import { render, staticRenderFns } from "./UserProfileDisplay.vue?vue&type=template&id=a6ebae6e"
import script from "./UserProfileDisplay.vue?vue&type=script&lang=js"
export * from "./UserProfileDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports